export enum EBarElementDock {
  bottom = 0,
  left,
  right,
  top
}